import { MasterCard, Card, Amex, Mada, Maestro, Rupay, Visa, SecuredBadge } from 'SVGPath/expressway'
import React from 'react'
import '../../../../containers/Expressway/expressway.scss'
import { getFormattedCardNumber } from 'AccountsUtils'

const SavedCardDetails = props => {
  const { cardNo, type, bank, tokenized, savedCardType, creditDebit } = props

  const getCardIcon = (cType = '') => {
    if (cType.toLowerCase() === 'mastercard') return <MasterCard />
    if (cType.toLowerCase() === 'amex' || cType.toLowerCase() === 'american_express') return <Amex />
    if (cType.toLowerCase() === 'mada') return <Mada />
    if (cType.toLowerCase() === 'maestro') return <Maestro />
    if (cType.toLowerCase() === 'rupay') return <Rupay />
    if (cType.toLowerCase() === 'visa') return <Visa />
    return <Card />
  }

  const getCardName = (cName = '') => {
    if (cName === 'C') {
      return 'Credit Card'
    } if (cName === 'D') {
      return 'Debit Card'
    }
    return ''
  }

  return (
    <div className="flex">
      <span className="flex flex-column flex-center w-50">
        {getCardIcon(type)}
      </span>
      <div>
        <div className="flex flex-left">
          <h3 className="grey-5 fw-500 fs-20 ml-1">
            {getFormattedCardNumber(cardNo)}
          </h3>
          {
            tokenized && (
              <div className="pl-8">
                <SecuredBadge />
              </div>
            )}
        </div>
        <div className="card-subtext grey-9 mt-1 ml-1">
          {savedCardType === 'TOKENIZED' && (bank || '')}{' '}
          {getCardName(creditDebit)}
        </div>
      </div>
    </div>
  )
}

export default SavedCardDetails
